//reasons for sellers to reject a buyer
export const REJECT_REASONS_SELLER_TO_BUYER = new Map([
    ["OTHER_REASON", "Other reason"],
    ["SELLER_TO_BUYER_NO_CONTACT", "The buyer's response takes too long"],
    ["SELLER_TO_BUYER_ITEM_NOT_FOUND", "You can no longer find the item"],
]);

//reasons for sellers to reject a bidder
export const REJECT_REASONS_SELLER_TO_BIDDER = new Map([
    ["OTHER_REASON", "Other reason"],
    ["SELLER_TO_BIDDER_UNWANTED_CURRENCY", "You are not interested in the offered currency"],
    ["SELLER_TO_BIDDER_BID_TOO_LOW", "The offered bid is too low"],
]);

//reasons for bidders to reject a bid
export const REJECT_REASONS_BIDDER_TO_SELLER = new Map([
    ["OTHER_REASON", "Other reason"],
    ["BIDDER_TO_SELLER_NO_CONTACT", "The seller's response takes too long"],
]);